import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import lineBreaker from 'helpers/LineBreaker';
import { formatarMoeda } from 'util/numberUtil';
import SemDados from '../SemDados';

const RegionalVerba = (props) => {
  const { data } = props;
  const titulo = 'VERBA UTILIZADA POR REGIONAL';

  if (!data || data.length < 1) {
    return <SemDados titulo={titulo} />;
  }

  console.log('RegionalVerba', data);

  // const dataTipos = ['Verba Utilizada', 'Verba Disponível'];

  const itensNomes = data.map((item) => {
    return item.nome;
  });

  const itensTotalCusto = data.map((item) => {
    return item.totalCusto;
  });

  const itensTotalVerba = data.map((item) => {
    return item.totalVerba;
  });

  const itensTotalAlocado = data.map((item) => {
    return item.totalAlocado;
  });

  const series = [
    {
      name: 'Verba Disponível',
      group: 'verba disponível',
      data: itensTotalVerba,
    },
    {
      name: 'Verba Alocada',
      group: 'verba utilizada',
      data: itensTotalAlocado,
    },
    {
      name: 'Verba Utilizada',
      group: 'verba utilizada',
      data: itensTotalCusto,
    },
  ];

  // somar os valores de Alocado e utilizado para comparar o maximo com o disponivel
  const maxDisponivel = Math.max(...series[0].data);
  const maxSoma = Math.max(...series[1].data) + Math.max(...series[2].data);
  const maxValue = Math.max(maxDisponivel, maxSoma);

  const options = {
    colors: ['#b4282f', '#e36823', '#FCC400'],
    legend: {
      showForSingleSeries: true,
      // formatter: (seriesName) => {
      //   return [seriesName.toUpperCase()];
      // },
      show: true,
      position: 'bottom',
      horizontalAlign: 'left',
      floating: false,
      offsetX: 0,
      offsetY: 0,
    },
    plotOptions: {
      bar: {
        hideZeroBarsWhenGrouped: false,
        horizontal: false,
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    stroke: {
      colors: ['transparent'],
      width: 4,
    },
    xaxis: {
      categories: [...itensNomes],
      show: true,
      labels: {
        show: true,
        offsetY: 0,
        style: {
          fontWeight: 600,
        },
        formatter: (value) => {
          const lines = lineBreaker(value, 7);
          return lines;
        },
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      max: maxValue * 1.2,
      show: false,
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      id: 'can-solicitacoes',
      stacked: true,
      parentHeightOffset: 5,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      // hideOverflowingLabels: false,
      textAnchor: 'middle',
      // offsetX: 0,
      offsetY: -16,
      formatter: (value) => {
        return value === null ? formatarMoeda(0) : formatarMoeda(value);
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        // colors: ['#ffffff'],
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Regional: <span id="data">${itensNomes[dataPointIndex]}</span>
            </span>
            <span>
              Verba Disponível: <span id="data">R$${formatarMoeda(
                series[0][dataPointIndex]
              )}</span>
            </span>
            <span>
              Verba Alocada: <span id="data">R$${formatarMoeda(
                series[1][dataPointIndex]
              )}</span>
            </span>
            <span>
              Verba Utilizada: <span id="data">R$${formatarMoeda(
                series[2][dataPointIndex]
              )}</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico" style={{ overflow: 'hidden' }}>
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <div className="scrollable-horizontal">
        <Chart
          options={options}
          series={series}
          type="bar"
          height="250"
          style={{
            width: options.xaxis.categories.length * 200,
            // minWidth: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default RegionalVerba;
